import { css } from '@emotion/react'
import { eerieBlack } from '../../style/colors'

export const cardStyle = css`
  border-radius: 10px;
  background: ${eerieBlack['0']};
  box-shadow: 0 2px 6px 0 #1C1C1C14, 0 1px 2px 0 #1C1C1C1F;
`
